import {
  SlBreadcrumbItem
} from "./chunk.O4GS7LIJ.js";
import {
  breadcrumb_item_styles_default
} from "./chunk.Y4LNCMYU.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/breadcrumb/breadcrumb-item.ts
var FadvBreadcrumbItem = class extends SlBreadcrumbItem {
  constructor() {
    super(...arguments);
    this.disabled = false;
  }
  interceptClick(event) {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
  connectedCallback() {
    super.connectedCallback();
    this.interceptClick = this.interceptClick.bind(this);
    this.addEventListener("click", this.interceptClick);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.interceptClick);
    super.disconnectedCallback();
  }
};
FadvBreadcrumbItem.styles = breadcrumb_item_styles_default;
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvBreadcrumbItem.prototype, "disabled", 2);
FadvBreadcrumbItem = __decorateClass([
  n("fadv-breadcrumb-item")
], FadvBreadcrumbItem);

export {
  FadvBreadcrumbItem
};
